import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-md" data-id="element-188">
      <div className="max-w-4xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-189">
        <span className="font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-190">
          Questa offerta scade presto
        </span>
        <CountdownTimer light data-id="element-191" />
      </div>
    </div>;
}